// In src/SurveyInsights.js

import { useState, useEffect } from 'react';
import { collection, query, onSnapshot, orderBy } from "firebase/firestore";
import { db } from './firebase';
import { Link } from 'react-router-dom';

function SurveyInsights() {
  const [responses, setResponses] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState('');

  useEffect(() => {
    const responsesRef = collection(db, "surveyResponses");
    const q = query(responsesRef, orderBy("submittedAt", "desc"));
    
    const unsubscribe = onSnapshot(q, (querySnapshot) => {
      const responsesData = [];
      querySnapshot.forEach((doc) => {
        responsesData.push({ id: doc.id, ...doc.data() });
      });
      setResponses(responsesData);
      setLoading(false);
    }, (err) => {
      console.error("Error fetching survey responses:", err);
      setError("Failed to load survey responses.");
      setLoading(false);
    });

    return () => unsubscribe();
  }, []);

  if (loading) return <p className="loading-text">Loading survey insights...</p>;
  if (error) return <p className="error-text">{error}</p>;

  return (
    <div className="card">
      <h2 className="page-header">Rider Survey Insights</h2>
      <p className="page-subheader">Live responses from passengers.</p>
      {responses.length === 0 ? (
        <p>No survey responses found yet.</p>
      ) : (
        <table className="table">
          <thead>
            <tr>
              <th>Submitted At</th>
              <th>Location</th>
              <th>Tablet ID</th>
              <th>Age</th>
              <th>Heritage</th>
              <th>Trip Purpose</th>
              <th>Interests</th>
              <th>Frequency</th>
            </tr>
          </thead>
          <tbody>
            {responses.map(res => (
              <tr key={res.id}>
                <td>{res.submittedAt?.toDate().toLocaleString()}</td>
                <td>{res.location}</td>
                <td>
                    <Link to={`/tablet/${res.tabletId}`} className="link-style">
                        {res.tabletId.substring(0, 8)}...
                    </Link>
                </td>
                <td>{res.age || 'N/A'}</td>
                <td>{res.heritage || 'N/A'}</td>
                <td>{res.tripPurpose || 'N/A'}</td>
                <td>{res.interests || 'N/A'}</td>
                <td>{res.rideshareFrequency || 'N/A'}</td>
              </tr>
            ))}
          </tbody>
        </table>
      )}
    </div>
  );
}

export default SurveyInsights;